import { z } from 'zod';

export const searchSchema = z.object({
  ma_quan: z.string().min(1, 'Mã quận/huyện là bắt buộc'),
  ten_quan: z.string().min(1, 'Tên quận/huyện là bắt buộc'),
  ten_quan2: z.string().optional().nullable().default(''),
  ma_tinh: z.string().optional().nullable().default(''),
  trang_thai: z.number().default(1)
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export interface DistrictFormattedData {
  ma_quan: string;
  ten_quan: string;
  ten_quan2: string | null;
  ma_tinh: string | null;
  status: string | number;
}
